import {Button} from '@mui/material';
import React, {Fragment} from 'react';

import {BookingScheduledEnum} from 'main/analytics/gaTagsEnum';
import {AlertModal} from 'presentation/components';
import {OperationStateTypesEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import {AppointmentsConfirmModal} from 'presentation/modules/myAppointments/ui/components/AppointmentsConfirmModal';
import {useConfirmToGoButton} from 'presentation/modules/myAppointments/ui/components/ConfirmToGoButton/hooks/useConfirmToGoButton';
import {ConfirmToGoButtonProps} from 'presentation/modules/myAppointments/ui/components/ConfirmToGoButton/types';
import Icon from 'presentation/icons';
import {TagChip} from './styles';

const {appointmentCard, confirmAppointmentModal, confirmAppointmentError} =
	translations['pt-br'].privateFlow.myAppointments;

const {confirmation} = translations['pt-br'].commons;

export function ConfirmButton({appointment}: ConfirmToGoButtonProps) {
	const {
		showConfirmButton,
		isPending,
		isError,
		isSubmitting,
		handleConfirm,
		description,
		setConfirmState,
	} = useConfirmToGoButton(appointment);

	if (!showConfirmButton) {
		return null;
	}

	return (
		<Fragment>
			{appointment.isConfirmed ? (
				<TagChip>
					<Icon name="check-circle-filled" size={16} />
					{appointmentCard.confirmed}
				</TagChip>
			) : (
				<Button
					variant="contained"
					size="medium"
					onClick={() => setConfirmState(OperationStateTypesEnum.PENDING)}
					data-tag-id={BookingScheduledEnum.CLICK_CONFIRMAR_PRESENCA}>
					{confirmAppointmentModal.actionButtonText}
				</Button>
			)}

			<AppointmentsConfirmModal
				open={isPending || isSubmitting}
				isDisabled={isSubmitting}
				isSubmitting={isSubmitting}
				subTitle={description()}
				handleAction={handleConfirm}
				onClose={() => setConfirmState(OperationStateTypesEnum.NONE)}
				onOpen={() => setConfirmState(OperationStateTypesEnum.PENDING)}
				appointment={appointment}
			/>

			<AlertModal
				description={confirmAppointmentError.description}
				headerTitle={confirmation}
				title={confirmAppointmentError.title}
				onClose={() => setConfirmState(null)}
				open={isError}
				variant="info"
			/>
		</Fragment>
	);
}
